import React, { useEffect, useState, useContext, useRef } from "react";

import { useNavigate } from "react-router-dom";
import axios from "axios";

import "antd/dist/antd.min.css";
import { Modal } from "react-bootstrap";
import { DataGrid } from "@material-ui/data-grid";
import { makeStyles } from "@material-ui/core/styles";
import { confirmAlert } from "react-confirm-alert";
import Badge from "react-bootstrap/Badge";
import Tooltip from "@mui/material/Tooltip";

//Global State import
import { useAtom } from "jotai";
import { gbState } from "../../../../components/shared/GlobalState";

import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import toast from "react-hot-toast";
//Context import
import AuthContext from "../../../../components/shared/Context";
import ExcelDownloader from "./ExcelDownloader"; // Import the ExcelDownloader component
import ExpiredProductsList from "./ExpiredProductsList";

const ListTCInventoryChild = () => {
  let navigate = useNavigate();
  const { loggedInUserDetails } = useContext(AuthContext);
  const [data, setData] = useState([]);
  const [unfilteredData, setUnfilteredData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [currentRecord, setCurrentRecord] = useState({});
  const [expiredProducts, setExpiredProducts] = useState();
  const [showExpired, setShowExpired] = useState(false);
  const [itemwiseExpiredQty, setItemwiseExpiredQty] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const searchRef = useRef();

  //Error Logging Service
  const { dateFormatter, errorLogApi } = useAtom(gbState);

  const badgeStatus = {
    0: { badge: "warning", label: "PENDING" },
    1: { badge: "primary", label: "PROCESSING" },
    2: { badge: "danger", label: "REJECTED" },
    3: { badge: "success", label: "COMPLETED" },
  };

  const calculateDaysLeft = (date) => {
    // Convert the given date string to a Date object
    const givenDate = new Date(date);

    // Calculate the difference between the current date and the given date in milliseconds
    const timeDiff = givenDate.getTime() - new Date().getTime();

    // Convert milliseconds to days and round down to the nearest integer
    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

    // Update the state with the number of days left
    //setDaysLeft(days);
    return days;
  };

  //Get Expired Product Data
  const getExpiredProductsData = () => {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    let urlLink = `${process.env.REACT_APP_API_URL}/tcpwstock/`;

    axios
      .get(urlLink, config)
      .then((res) => {
        const oldData = res.data.product_stock;
        const ExpiredProduct = oldData.filter((product) => {
          return calculateDaysLeft(product?.product_stock?.expiry_date) <= 0;
        });
        const updatedData = ExpiredProduct.map((data) => {
          return {
            ...data,
            id: data?._id,
            stock_type: data?.product_stock?.stock_type,
            product_name:
              data?.product_stock?.product_id?.products?.product_name,
            category:
              data?.product_stock?.product_id?.products?.category_id?.category,
            item_code: data?.product_stock?.item_code,
            measuring_unit:
              data?.product_stock?.product_id?.products?.measuring_unit,
            company_name:
              data?.product_stock?.product_id?.products?.company_name,
            product_expiry: data?.product_stock?.expiry_date,
            tc_name: data?.product_stock?.tc_id?.tcenters?.name_tc,
            state: data?.product_stock?.tc_id?.tcenters?.state,
            quantity:
              data?.product_stock?.quantity +
              " " +
              data?.product_stock?.product_id?.products?.storage_unit,
            updatedAt: data?.updatedAt,
          };
        });
        setExpiredProducts(updatedData);
      })
      .catch((err) => console.log("error", err));
  };

  //Modify the useEffect to use the new function
  useEffect(() => {
    getExpiredProductsData();
  }, []);

  //Get Current Stock
  const getDataFromServer = () => {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    let urlLink = `${process.env.REACT_APP_API_URL}/tcstock`;

    axios
      .get(urlLink, config)
      .then((res) => {
        const oldData = res?.data?.current_stock;
        //console.log(oldData);
        const updatedData = oldData?.map((data) => {
          //   console.log(data.purchase_inventory.product_id.products);
          return {
            ...data,
            id: data?._id,
            product_name:
              data?.current_stock?.product_id?.products?.product_name,
            category:
              data?.current_stock?.product_id?.products?.category_id?.category,
            item_code: data?.current_stock?.item_code,
            opening_stock:
              data?.current_stock?.opening_stock +
              " " +
              data?.current_stock?.product_id?.products?.storage_unit,
            purchase_qty:
              data?.current_stock?.purchase_qty +
              " " +
              data?.current_stock?.product_id?.products?.storage_unit,
            sale_qty:
              data?.current_stock?.sale_qty +
              " " +
              data?.current_stock?.product_id?.products?.storage_unit,
            expired_qty:
              "0 " + data?.current_stock?.product_id?.products?.storage_unit,
            useable_closing_qty:
              data?.current_stock?.closing_stock +
              " " +
              data?.current_stock?.product_id?.products?.storage_unit,
            closing_stock:
              data?.current_stock?.closing_stock +
              " " +
              data?.current_stock?.product_id?.products?.storage_unit,
            state: data?.current_stock?.tc_id?.tcenters?.state,
            tc_name: data?.current_stock?.tc_id?.tcenters?.name_tc,
            updatedAt: data?.updatedAt,
          };
        });
        //console.log(updatedData);
        setData(updatedData);
        setUnfilteredData(updatedData);
      })
      .catch((err) => console.log("error", err));
  };

  //Load the current stock from database
  useEffect(() => {
    // if (loggedInUserDetails.tc_id) {
    getDataFromServer();
    // }
  }, []);

  //Once the Expierd product is loaded
  useEffect(() => {
    if (expiredProducts?.length > 0) {
      // Group expired products by item_code and sum quantities
      const itemwiseQty = expiredProducts.reduce((acc, product) => {
        const itemCode = product.item_code;
        const quantity = parseInt(product.quantity?.split(" ")[0]) || 0;

        if (!acc[itemCode]) {
          acc[itemCode] = {
            item_code: itemCode,
            quantity: 0,
          };
        }
        acc[itemCode].quantity += quantity;
        return acc;
      }, {});

      // Convert to array format
      const itemwiseQtyArray = Object.values(itemwiseQty);
      setItemwiseExpiredQty(itemwiseQtyArray);
    }
  }, [expiredProducts]);

  //When itemwiseexpired is set then again refill the data
  useEffect(() => {
    if (itemwiseExpiredQty?.length > 0) {
      // Create a map of expired quantities by item code
      const expiredQtyMap = itemwiseExpiredQty.reduce((acc, item) => {
        acc[item.item_code] = item.quantity;
        return acc;
      }, {});

      // Add expired_qty field and update closing_stock for each row in data
      const updatedData = data.map((row) => {
        const expiredQty = expiredQtyMap[row.item_code] || 0;
        const currentClosingStock =
          parseInt(row.closing_stock?.split(" ")[0]) || 0;
        const storageUnit =
          row.current_stock?.product_id?.products?.storage_unit;

        return {
          ...row,
          expired_qty: expiredQty + " " + storageUnit,
          closing_stock: currentClosingStock + " " + storageUnit,
          useable_closing_qty:
            currentClosingStock - expiredQty + " " + storageUnit,
        };
      });
      setData(updatedData);
    }
  }, [itemwiseExpiredQty]);

  const useStyles = makeStyles(() => ({
    multiLineCell: {
      display: "flex",
      wordBreak: "keep-all",
      wordWrap: "break-word",
      overflowWrap: "break-word",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      lineHeight: "1.2rem",
      height: "auto",
    },
  }));

  const MultiLineCellRenderer = (params) => {
    const classes = useStyles();
    return (
      <Tooltip title={params.row.product_name}>
        <div className={classes.multiLineCell}>
          <span id="content1" className="text-bold">
            {params.row.product_name}
          </span>
          <span id="content2">
            <small className=" small-font-size">
              {params.row.item_code} ({params.row.category})
            </small>
          </span>
        </div>
      </Tooltip>
    );
  };

  const columns = [
    {
      field: "product_name",
      headerName: "Product",
      width: 240,
      renderCell: MultiLineCellRenderer,
    },
    {
      field: "opening_stock",
      headerName: "Opening Stock",
      width: 160,
      filterable: false,
      disableColumnMenu: true,
      align: "center",
    },
    {
      field: "purchase_qty",
      headerName: "Alloted",
      width: 110,
      filterable: false,
      sortable: true,
      disableColumnMenu: true,
      align: "center",
    },
    {
      field: "sale_qty",
      headerName: "Consumed",
      width: 130,
      filterable: false,
      sortable: true,
      disableColumnMenu: true,
      align: "center",
    },
    {
      field: "expired_qty",
      headerName: "Expired",
      width: 130,
      filterable: false,
      sortable: true,
      disableColumnMenu: true,
      align: "center",
      renderCell: (params) => {
        // Extract numeric value from string like "120 vial(s)"
        const numericValue = parseInt(params?.row?.expired_qty?.split(" ")[0]);
        return (
          <Badge
            bg={numericValue > 0 ? "danger" : "success"}
            style={{ width: "100%", display: "block", fontSize: "0.8rem" }}
          >
            {params?.row?.expired_qty}
          </Badge>
        );
      },
    },
    //useable_closing_qty
    {
      field: "useable_closing_qty",
      headerName: "Useable Stock",
      width: 160,
      filterable: false,
      disableColumnMenu: true,
      align: "center",
      renderCell: (params) => (
        <div style={{ fontWeight: "bold" }}>
          {params.row.useable_closing_qty}
        </div>
      ),
    },
    {
      field: "closing_stock",
      headerName: "Total Closing",
      width: 160,
      filterable: false,
      disableColumnMenu: true,
      align: "center",
    },
    {
      field: "category",
      headerName: "Category",
      width: 150,
    },
    {
      field: "tc_name",
      headerName: "TC Name",
      width: 170,
      filterable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => <div>{params?.row?.tc_name}</div>,
    },
    {
      field: "state",
      headerName: "State",
      width: 110,
      filterable: false,
      sortable: false,
      disableColumnMenu: true,
    },
  ];

  const viewRecord = (rec) => {
    setCurrentRecord(rec);
    setOpenModal(true);
  };

  const handleSearch = (e) => {
    console.log("Search Value...", e);

    if (e) {
      setData(
        unfilteredData?.filter((item) => {
          return (
            item?.item_code?.toLowerCase().includes(e?.toLowerCase()) ||
            item?.product_name?.toLowerCase().includes(e?.toLowerCase()) ||
            item?.purchase_qty?.toLowerCase().includes(e?.toLowerCase()) ||
            item?.sale_qty?.toLowerCase().includes(e?.toLowerCase()) ||
            item?.closing_stock?.toLowerCase().includes(e?.toLowerCase())
          );
        })
      );
    } else {
      getDataFromServer();
      setData(unfilteredData);
    }
  };

  const clearSearch = () => {
    searchRef.current.value = null;
    getDataFromServer();
  };

  const tcinventorySettle = () => {
    // alert("inventory Settled");

    confirmAlert({
      title: "",
      message: "Are you sure to Settle Inventory ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => confirmInventorySettle(),
        },
        {
          label: "No",
          //onClick: () => alert('Click No')
        },
      ],
    });

    const confirmInventorySettle = () => {
      let urlLink = `${process.env.REACT_APP_API_URL}/tcs/stocksettle`;

      const config = {
        method: "post",
        url: urlLink,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        data: { invdata: true },
      };

      axios(config)
        .then((res) => {
          // console.log("response", res, "data", res.data[0]);
          toast.success(res?.data?.message);
          getDataFromServer();
        })
        .catch((err) => {
          console.log();
          if (err?.response?.data?.error) toast.error("Already settled");
          errorLogApi(err, "ListTCInventoryChild", urlLink);
        });
    };
  };

  const reloadInventory = () => {
    confirmAlert({
      title: "",
      message: "Are you sure to Reload Inventory ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => confirmReloadInventory(),
        },
        {
          label: "No",
          //onClick: () => alert('Click No')
        },
      ],
    });

    const confirmReloadInventory = () => {
      let urlLink = `${process.env.REACT_APP_API_URL}/tcstock/reload`;

      const config = {
        method: "get",
        url: urlLink,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };

      axios(config)
        .then((res) => {
          // console.log("response", res, "data", res.data[0]);
          getDataFromServer();
        })
        .catch((err) => {
          console.log();
          if (err?.response?.data?.error) toast.error("Already settled");
          errorLogApi(err, "ListTCInventoryChild", urlLink);
        });
    };
  };

  //Update the refresh function to fetch both current stock and expired products
  const refreshData = () => {
    getDataFromServer();
    getExpiredProductsData();
  };

  //Bulk Delete function
  const handleSelectionChange = (selectionModel) => {
    // `selectionModel` will be an array of IDs of selected rows
    setSelectedIds(selectionModel);
  };

  const deleteMultipleRecords = () => {
    let inputCode = "";
    if (!selectedIds?.length) return toast.error("Please select Record(s)");

    confirmAlert({
      title: "",
      message: "Are you sure to delete record(s) ?",
      childrenElement: () => (
        <div>
          {/* Use the key here */}
          <input
            type="text"
            placeholder="Type Code..."
            className="mt-2"
            onChange={(e) => (inputCode = e.target.value)} // Direct assignment
          />
        </div>
      ),
      buttons: [
        {
          label: "Yes",
          onClick: () => deleteRecordInBulk(inputCode),
        },
        {
          label: "No",
          //onClick: () => alert('Click No')
        },
      ],
    });
  };

  const deleteRecordInBulk = (inputCode) => {
    if (!inputCode) return toast.error("Please enter a valid code!");

    let userToken = localStorage.getItem("token");
    const config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/tcstock/delete/bulk`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      data: { ids: selectedIds, secret_code: inputCode },
    };
    if (selectedIds.length > 0) {
      axios(config)
        .then(function (response) {
          getDataFromServer();
          toast.success("Stock Deleted Successfully.");
        })
        .catch(function (error) {
          errorLogApi(error, "PWStockDeleteMany", "/delete/bulk");
          toast.error(JSON.stringify(error.response.data.message));
        });
    }
  };

  return (
    <div>
      <span className="card-title">
        <h3>Total TC Stocks (Current Status)</h3>
      </span>

      <div className="text-end">
        <button className="btn btn-success" onClick={refreshData}>
          <i className="mdi mdi-refresh"></i>
        </button>{" "}
        &nbsp;&nbsp;
        <button className="btn btn-primary" onClick={tcinventorySettle}>
          TC Settle Inventory
        </button>{" "}
        &nbsp;&nbsp;
        {/* {!data?.length && (
          <button className="btn btn-warning" onClick={reloadInventory}>
            Reload
          </button>
        )} */}
        <ExcelDownloader
          data={data}
          filename={`inventory_status_${new Date()
            .toISOString()
            .replace(/[-:.]/g, "")}.xlsx`}
          excludedFields={[
            "_id",
            "id",
            "s_register",
            "__v",
            "patient_record",
            "visit_record",
            "current_stock",
          ]}
        />
        {loggedInUserDetails?.force_delete === true && (
          <button
            className="btn btn-danger ms-2"
            onClick={deleteMultipleRecords}
          >
            <i className="mdi mdi-delete "></i>
          </button>
        )}
      </div>
      <div className="patientListSearch">
        <InputGroup className="mb-3">
          <InputGroup.Text id="basic-addon1">Filter</InputGroup.Text>
          <Form.Control
            placeholder="Product / State / Code / Company ..."
            aria-label="Search"
            aria-describedby="basic-addon1"
            name="searchPatients"
            ref={searchRef}
            onChange={(e) => handleSearch(e.target.value)}
          />
          <InputGroup.Text>
            <i
              className="mdi mdi-delete-outline"
              onClick={clearSearch}
              style={{ cursor: "pointer" }}
            ></i>
          </InputGroup.Text>
        </InputGroup>
      </div>
      <DataGrid
        rows={data}
        disableSelectionOnClick
        columns={columns}
        pageSize={10}
        rowsPerPageOptions={[10, 25, 50]}
        displayTitle="Current Stocks"
        checkboxSelection
        style={{ height: "60vh" }}
        onSelectionModelChange={handleSelectionChange}
      />
      {/* {expiredProducts?.length > 0 && (
        <div className="mt-3">
          <div
            className="d-flex align-items-center"
            style={{ cursor: "pointer" }}
            onClick={() => setShowExpired(!showExpired)}
          >
            <h4 className="mb-0 d-flex align-items-center">
              <span>Expired Items</span>
              <span className="ms-2 badge bg-danger rounded-pill">
                {expiredProducts.length}
              </span>
              <i
                className={`ms-2 mdi mdi-chevron-${
                  showExpired ? "up" : "down"
                }`}
              ></i>
            </h4>
          </div>
          {showExpired && <ExpiredProductsList />}
        </div>
      )} */}

      {/* Modal Popup */}
      <Modal show={openModal} centered>
        <Modal.Header closeButton onClick={() => setOpenModal(false)}>
          <Modal.Title>Stocks Detail</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalContent currentRecord={currentRecord} />
        </Modal.Body>
      </Modal>

      {/* {JSON.stringify(currentRecord)} */}
    </div>
  );
};

const ModalContent = ({ currentRecord }) => {
  const dateFormatter = (date) => {
    const date_conv = new Date(date);
    const fullyear = date_conv.getFullYear();
    const month = date_conv.getMonth() + 1;
    const day = date_conv.getDate();
    return `${day}/${month}/${fullyear}`;
  };

  return (
    <div className="container-fluid">
      <table class="table table-striped">
        <tbody>
          <tr>
            <th scope="row">Product Name</th>
            <td>{currentRecord?.product_name}</td>
          </tr>
          <tr>
            <th scope="row">Measuring Units</th>
            <td>{currentRecord?.measuring_unit}</td>
          </tr>
          <tr>
            <th scope="row">Drug Category</th>
            <td>{currentRecord?.category}</td>
          </tr>
          <tr>
            <th scope="row">Quantity</th>
            <td>{currentRecord?.quantity}</td>
          </tr>
          <tr>
            <th scope="row">Expiry</th>
            <td>{dateFormatter(currentRecord?.product_expiry)}</td>
          </tr>
          <tr>
            <th scope="row">Company Name</th>
            <td>{currentRecord?.company_name}</td>
          </tr>
          <tr>
            <th scope="row">State</th>
            <td>{currentRecord?.state}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default ListTCInventoryChild;
